module.exports = "https://web-assets.ifttt.com/packs/media/card_brands/discover-58372731.png";